import React from 'react';
import { withTranslation } from 'react-i18next';
import InfoBar from './InfoBar';

function PrinterV3InfoBar({ isPrintable, notPrintableReason, t }) {
  const getNotPrintableMessage = (reason) => {
    // Silent reasons that should not display anything
    if (['no_jobs', 'email_missing', 'payment_needed'].includes(reason)) {
      return null;
    }

    const messages = {
      'not_enough_paper': {caption: t('printerInfoBar.notPrintable.notEnoughPaper'), type: 'error'},
      'printer_serviced': {caption: t('printerInfoBar.notPrintable.printerServiced'), type: 'error'},
      'printer_not_selected': {caption: t('printerInfoBar.notPrintable.printerNotSelected'), type: 'info'}
    };
    return messages[reason] || {caption: t('printerInfoBar.notPrintable.printerNotAvailable'), type: 'error'};
  };

  const message = getNotPrintableMessage(notPrintableReason);

  return (
    <>
      {/* V3 specific InfoBar components */}
      { !isPrintable && notPrintableReason && message &&
      <InfoBar
        caption={<span dangerouslySetInnerHTML={{ __html: message.caption }} />}
        type={message.type} />
      }
    </>
  );
}

export default withTranslation()(PrinterV3InfoBar);
